import React from "react";
import { CONTACT_IMG } from "../../lib/assets";
import { COMPANY } from "../../content/siteContent";
import { ContactNumbers } from "../ContactNumbers/ContactNumbers";

export const ContactAreaInner = () => {
  return (
    <section className="inner-contact-area pt-120 pb-120">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="inner-contact-img">
              <img src={CONTACT_IMG} alt="" />
            </div>
          </div>

          <div className="col-lg-6">
            <div className="inner-contact-info">
              <h2 className="title">Our Offices</h2>
              {COMPANY.offices.map((office) => (
                <div className="contact-info-item" key={office.name}>
                  <h5 className="title-two">{office.name}</h5>
                  <ul className="list-wrap">
                    {office.lines.map((line) => (
                      <li key={line}>{line}</li>
                    ))}
                  </ul>
                </div>
              ))}
              <div className="contact-info-item">
                <h5 className="title-two">Contact Details</h5>
                <ContactNumbers />
                <ul className="list-wrap contact-email-list">
                  <li>Email: {COMPANY.email}</li>
                </ul>
              </div>
              <div className="contact-info-item">
                <h5 className="title-two">Working Hours</h5>
                <ul className="list-wrap">
                  {COMPANY.workingHours.map((line) => (
                    <li key={line}>{line}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
